<template>
    <div class="contain">
        <div class="containLeft">
            <div class="areaInfo">
                <div class="roadInfo1">
                    <div class="containTitle">项目信息</div>
                    <div style="display: flex;justify-content: end" class="pipeInfo">
                        <InputField label="" type="text" id="project" class="projectInfo"
                                    label-width="0" input-width="100%" style="width: 120px;margin-right: 1rem;"
                                    :modelValue="proForm.projectName" placeholder="项目名称"
                                    @update:modelValue="(value) => handleModelValueUpdate('projectName', value)"
                        />
                        <ButtonField text="查询" @click="getTestItemList" secondary style="margin-right: 1rem;width: 70px;"/>
                        <ButtonField text="新增" @click="addProject" primary style="margin-right: 1rem;width: 70px;"/>
                    </div>
                </div>
                <areaTableList
                        :showCheckbox="false"
                        :list="testItemList"
                        :columns="tableColumns1"
                        :totalSize="totalSize"
                        :totalPages="totalPages"
                        :pageNum="pageNum"
                        :pageSize="pageSize"
                        @page-change="onChange"
                        @row-click="handleProRowClick"
                >
                    <template v-slot:actions="{ item }">
                        <a-space>
                            <a href="#" @click.prevent="projectDetailsText(item)">详情</a>
                            <a href="#" @click.prevent="projectEditText(item)">编辑</a>
                            <a href="#" @click.prevent="addTieIn(item)">新增管段</a>
                            <a href="#" class="danger" @click.prevent="delProText(item)">删除</a>
                        </a-space>
                    </template>
                </areaTableList>
            </div>
            <div class="roadInfo">
                <div class="roadInfo1">
                    <div class="containTitle">管段信息</div>
                    <div style="display: flex;justify-content: end" class="pipeInfo">
                        <InputField label="" type="text" id="project" class="projectInfo"
                                    label-width="0" input-width="100%" style="width: 120px;margin-right: 1rem;"
                                    :modelValue="pipeForm.code" placeholder="编号"
                                    @update:modelValue="(value) => handleModelValueUpdate('projectName', value)"
                        />
                        <ButtonField text="查询" @click="getDefectInfoList" secondary style="margin-right: 1rem;width: 70px;"/>
                        <ButtonField v-if="proShow" text="新增" @click="addTieIn" primary style="margin-right: 1rem;"/>
                    </div>
                </div>
                <areaTableList :showCheckbox="false" :list="defectInfoList"
                               :totalSize="totalInfoSize" :totalPages="totalInfoPages"  :pageNum="pageInfoNum"
                               :pageSize="pageInfoSize" @row-click="handleRowClick"
                               :columns="tableColumns2" @toggle-unfold="toggleUnfold" @action="handleTableAction">
                    <template v-slot:actions="{ item }">
                        <a-space>
                            <!--                            <a href="#" @click.prevent="showGis(item)">位置</a>-->
                            <a href="#" @click.prevent="roadEditText(item)">编辑缺陷</a>
                            <a href="#" class="danger" @click.prevent="delPipeText(item)">删除</a>
                        </a-space>
                    </template>
                </areaTableList>
            </div>
        </div>
        <div class="containright">
            <div class="roadInfo1">
                <div class="containTitle">缺陷信息</div>
                <div style="display: flex;justify-content: end">
                    <ButtonField text="✐ 缺陷编辑" @click="EditDefect" primary style="margin-right: 1rem;"/>
<!--                    <ButtonField text="经纬度修改增加" @click="getTest" primary style="margin-right: 1rem;"/>-->
                </div>
            </div>
            <flawDetail :defect="defect" :tieInDetail="tieInDetail" :tieInhList="tieInhList" @pipeVisible="pipeVisible = $event" @delete="handleDeletePipe" @update="handleDefectPipeShowUpdate" @save="handleDefectPipeInfoSave"/>
        </div>


        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="gisShow?'gis定位':'管段信息'"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="visible = $event">
            <gisIndex class="gisIndex" :gisShow="gisShow" :pipeInfo="pipeInfo" :proInfo="proInfo" @cancel="visible = $event"  @save="handleDefectInfoSave"/>
        </Modal>


        <Modal v-if="projectVisible" v-model="projectVisible"
               :visible="projectVisible"
               title="项目信息"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="projectVisible = $event">
            <projectIndex :isDetails="isDetails" :projectInfo="projectInfo" @cancel="projectVisible = $event"  @save="handleTestItemSave" @update="handleTestItemUpdate"/>
        </Modal>
        <Modal v-if="tieInVisible" v-model="tieInVisible"
               :visible="tieInVisible"
               title="缺陷信息"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="tieInVisible = $event">
            <tieInIndex :defect="defect" :tieInDetail="tieInDetail" @cancel="tieInVisible = $event" @update="handleDefectInfoUpdate"/>
        </Modal>
        <Modal v-if="pipeVisible" v-model="pipeVisible"
               :visible="pipeVisible"
               title="新增缺陷"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'70%'"
               @update:visible="pipeVisible = $event">
            <pipeNum :defect="defect" :tieInDetail="tieInDetail" :defectPipeInfo="defectPipeInfo" @cancel="pipeVisible = $event" @save="handleDefectPipeSave" @update="handleDefectPipeUpdate"/>
        </Modal>
    </div>
</template>

<script>
//saveTest1,
import {saveLine,saveTest1,fetchTestItemList,fetchDefectInfoList,
    fetchDefectPipeList,saveTestItem,saveDefectInfo,saveDefectPipe,
    remove,editTestItem,editDefectInfo,editDefectPipe} from "./api/detection";
import areaTableList  from "@/views/topic/detection/area-table-list.vue";
import flawDetail from "@/views/topic/detection/flaw-detail.vue";
import gisIndex from "@/views/topic/detection/gis.vue"
import projectIndex from "@/views/topic/detection/components/project.vue"
import tieInIndex from "@/views/topic/detection/components/tieIn.vue"
import pipeNum from "@/views/topic/detection/components/pipe_num.vue"
export default {
    name: "index",
    components:{
        areaTableList,flawDetail,gisIndex,projectIndex,tieInIndex,pipeNum
    },
    data() {
        return {
            pipeVisible:false,
            proShow:false,
            snForm:{},
            pipeForm:{},
            proForm:{},
            proInfo:{},
            tieInVisible:false,
            projectVisible:false,
            visible:false,
            defectPipeShow:false,
            defectPipeInfo:[],
            testItemList:[],
            defectInfoList:[],
            tieInhList:[],
            tableColumns1:[
                {key: 'projectName',title: '项目',field: 'projectName',width: '100px'},
                {key: 'totalQuantity',title: '总数量',field: 'totalQuantity',width: '100px'},
                {key: 'totalLength',title: '总长度(m)',field: 'totalLength',width: '100px'},
                {key: 'remark',title: '备注',field: 'remark',width: '100px'},
                {key: 'testDate',title: '日期',field: 'testDate',width: '100px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '140px'},
            ],
            tableColumns2:[
                {key: 'code',title: '管段',field: 'code',infotype: 'text',width: '100px'},
                {key: 'location',title: '位置',field: 'location',infotype: 'text',width: '100px'},
                {key: 'material',title: '材质',field: 'material',infotype: 'text',width: '80px'},
                {key: 'diameter',title: '管径(mm)',field: 'diameter',infotype: 'text',width: '100px'},
                {key: 'length',title: '管长(m)',field: 'length',infotype: 'text',width: '100px'},
                {key: 'testDate',title: '创建日期',field: 'testDate',infotype: 'text',width: '100px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '150px'},
            ],
            currentChildren: [],
            tieInDetail:{
                id:1,code:null,material:null,length:null,diameter:null,location:null,
                buringDepthFrom:null,buringDepthTo:null,elevationFrom:null,elevationTo:null
            },
            pipeInfo:{},
            projectInfo:{},
            tieInInfo:{},
            gisShow:false,
            defect:{},
            loading: false,
            totalSize: 1,
            totalPages: 1,
            pageNum: 1,
            pageSize: 10,

            totalInfoSize: 1,
            totalInfoPages: 1,
            pageInfoNum: 1,
            pageInfoSize: 10,

            totalPipeSize: 1,
            totalPipePages: 1,
            pagePipeNum: 1,
            pagePipeSize: 10,

            isSubmitting:false,
            isDetails:false,


            progressVisible: false,
            progress: 0,
            errorMessage: ''
        }
    },
    beforeDestroy() {
        this.destroyReglBuffer();
    },
    mounted() {
        this.getTestItemList();
    },
    methods: {
        async getTest() {
            this.isSubmitting = true;
            this.progressVisible = true;
            this.progress = 0;

            try {
                const response = await fetch('/gis/line.json'); // 假设文件在 public 目录下
                const lineData = await response.json();

                if (!lineData.features || !Array.isArray(lineData.features)) {
                    throw new Error('无效的JSON结构，缺少features数组');
                }

                // 2. 遍历处理每个feature
                const total = lineData.features.length;
                for (let i = 0; i < total; i++) {
                    const feature = lineData.features[i];
                    await this.processFeature(feature);
                    this.progress = Math.round(((i + 1) / total) * 100);
                }

                this.$message.success('所有线路数据处理完成');
            } catch (error) {
                console.error('数据处理失败:', error);
                this.errorMessage = error.message || '数据处理失败，请检查文件或重试';
            } finally {
                this.isSubmitting = false;
                // 3秒后隐藏进度条
                setTimeout(() => {
                    this.progressVisible = false;
                    this.progress = 0;
                }, 3000);
            }
        },
        async getTest1() {
            this.isSubmitting = true;
            this.progressVisible = true;
            this.progress = 0;

            try {
                const response = await fetch('/gis/point.json'); // 假设文件在 public 目录下
                const pointData = await response.json();

                if (!pointData.features || !Array.isArray(pointData.features)) {
                    throw new Error('无效的JSON结构，缺少features数组');
                }

                // 遍历处理每个feature
                const total = pointData.features.length;
                for (let i = 0; i < total; i++) {
                    const feature = pointData.features[i];
                    await this.processFeature1(feature);
                    this.progress = Math.round(((i + 1) / total) * 100);
                }

                this.$message.success('所有点数据处理完成');
            } catch (error) {
                console.error('数据处理失败:', error);
                this.errorMessage = error.message || '数据处理失败，请检查文件或重试';
            } finally {
                this.isSubmitting = false;
                // 3秒后隐藏进度条
                setTimeout(() => {
                    this.progressVisible = false;
                    this.progress = 0;
                }, 3000);
            }
        },
        async processFeature1(feature) {
            try {
                // 提取坐标信息 (经纬度)
                const coordinates = feature.geometry?.coordinates || [];
                if (coordinates.length < 2) {
                    throw new Error(`FID为${feature.properties?.FID}的要素坐标不完整`);
                }
                // coordinates格式为[经度, 纬度, 高程]
                const [longitude, latitude = 0] = coordinates;

                // 解析TextString信息
                const textString = feature.properties?.TextString || '';
                const textParts = textString.split('/').map(part => part.trim());
                if (textParts.length < 3) {
                    throw new Error(`FID为${feature.properties?.FID}的TextString格式不正确: ${textString}`);
                }
                const [code,elevation, depth] = textParts;

                // 构造pipe_xy_point表单数据
                const form = {
                    id: feature.properties?.FID?.toString() || '', // 使用FID作为id
                    x: longitude.toString(),
                    y: latitude.toString(),
                    code: code,
                    accessary: '', // 原始数据中未提供，留空
                    depth: depth,
                    location: '', // 原始数据中未提供，留空
                    elevation: elevation.toString(),
                    longitude: longitude.toString(),
                    latitude: latitude.toString()
                };

                // 调用添加点的方法（假设为addPoint）
                await this.addTest(form);

            } catch (error) {
                console.error(`处理要素失败:`, error);
                throw new Error(`处理要素失败: ${error.message}`);
            }
        },
        async processFeature(feature) {
            try {
                // 提取QDDH和ZDDH
                const amMpipeP = feature.properties?.AM_MPIPE_P || '';
                const qddhMatch = amMpipeP.match(/"QDDH:([^"]*)"/);
                const zddhMatch = amMpipeP.match(/"ZDDH:([^"]*)"/);

                const pointFrom = qddhMatch ? qddhMatch[1] : '';
                const pointTo = zddhMatch ? zddhMatch[1] : '';

                // 提取坐标信息
                const coordinates = feature.geometry?.coordinates || [];
                if (coordinates.length < 2) {
                    throw new Error(`FID为${feature.properties?.FID}的要素坐标不完整`);
                }

                const [xFormNum, yFormNum] = coordinates[0];
                const [xToNum, yToNum] = coordinates[1];

                // 构造code
                const code = `${pointFrom.replace(/[:-]/g, '')}-${pointTo.replace(/[:-]/g, '')}`;

                // 构造表单数据
                const form = {
                    pointFrom,
                    pointTo,
                    xform: xFormNum.toString(),
                    yform: yFormNum.toString(),
                    xto: xToNum.toString(),
                    yto: yToNum.toString(),
                    code
                };

                // 调用addLine方法
                await this.addLine(form);

            } catch (error) {
                console.error(`处理要素失败:`, error);
                throw new Error(`处理要素失败: ${error.message}`);
            }
        },
        addLine(form) {
            console.log("addLine == form:::",form)

            return new Promise((resolve, reject) => {
                this.isSubmitting = true;

                console.log(`addLine   失败:`, form);

                saveLine(form)
                    .then(() => {
                        this.$message.success(`数据 ${form.code} 保存成功`);
                        resolve();
                    })
                    .catch((error) => {
                        console.error(`数据 ${form.code} 编辑失败:`, error);
                        this.$message.error(`数据 ${form.code} 编辑失败，请稍后再试`);
                        reject(error);
                    })
                    .finally(() => {
                        this.isSubmitting = false;
                    });
            });
        },
        addTest(form) {
            console.log("addLine == form:::",form)
            return new Promise((resolve, reject) => {
                this.isSubmitting = true;
                saveTest1(form)
                    .then(() => {
                        this.$message.success(`数据 ${form.code} 保存成功`);
                        resolve();
                    })
                    .catch((error) => {
                        console.error(`数据 ${form.code} 编辑失败:`, error);
                        this.$message.error(`数据 ${form.code} 编辑失败，请稍后再试`);
                        reject(error);
                    })
                    .finally(() => {
                        this.isSubmitting = false;
                    });
            });
        },
        handleDefectPipeUpdate(item){
            console.log("item::",item)

            this.isSubmitting = true;
            editDefectPipe(item).then(() =>{
                this.$message.success('创建成功');
                this.getDefectPipeList();
            }).catch((error) => {
                console.error('Error creating task:', error);
                this.$message.error('创建失败，请稍后再试');
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        handleDefectInfoUpdate(item){
            this.isSubmitting = true;
            editDefectInfo(item).then(() =>{
                this.$message.success('创建成功');
                this.getDefectInfoList();
            }).catch((error) => {
                console.error('Error creating task:', error);
                this.$message.error('创建失败，请稍后再试');
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        handleTestItemUpdate(item){
            this.isSubmitting = true;
            editTestItem(item).then(() =>{
                this.$message.success('创建成功');
                this.getTestItemList();
            }).catch((error) => {
                console.error('Error creating task:', error);
                this.$message.error('创建失败，请稍后再试');
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        handleProRowClick(item){
            this.proShow = true;
            this.pipeForm.defectId = item.id;
            this.proInfo = item;
            this.getDefectInfoList();
            this.tieInhList = []
        },
        handleRowClick(item) {
            this.tieInDetail = item;
            this.defect = item;
            this.snForm.defectInfoId = item.id;
            this.getDefectPipeList();
        },
        handleModelValueUpdate(fieldName, value) {
            this.proForm[fieldName] = value;
        },
        handleDefectPipeSave(item){
            this.isSubmitting = true;
            saveDefectPipe(item).then(() =>{
                this.$message.success('创建成功');
                this.getDefectPipeList();
            }).catch((error) => {
                console.error('Error creating task:', error);
                this.$message.error('创建失败，请稍后再试');
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        handleDefectInfoSave(form){
            this.isSubmitting = true;
            saveDefectInfo(form).then(() =>{
                this.$message.success('创建成功');
                this.getDefectInfoList();
            }).catch((error) => {
                console.error('Error creating task:', error);
                this.$message.error('创建失败，请稍后再试');
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        handleTestItemSave(form){
            this.isSubmitting = true;
            saveTestItem(form).then(() =>{
                this.$message.success('项目创建成功');
                this.getTestItemList();
            }).catch((error) => {
                console.error('Error creating task:', error);
                this.$message.error('项目创建失败，请稍后再试');
            }).finally(() => {
                this.isSubmitting = false;
            });
        },
        onChange(pagination) {
            this.pageNum  = pagination;
            this.pageSize = 10;
            this.getTestItemList();
        },
        getTestItemList(){
            this.loading = true;
            fetchTestItemList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                ...this.proForm,
            }).then((res) => {
                this.loading = false;
                if (Array.isArray(res.list)) {
                    this.testItemList = res.list.map(item => ({
                        ...item,
                        testDate: this.formatDate(item.testDate)
                    }));
                    console.log("this.testItemList:::",this.testItemList)
                    this.totalSize = res.totalSize;
                    this.totalPages = res.totalPages;
                }
            })
                .catch(() => {
                    this.loading = false;
                });
        },
        getDefectInfoList(){
            this.loading = true;
            fetchDefectInfoList({
                pageNum: this.pageInfoNum,
                pageSize: this.pageInfoSize,
                ...this.pipeForm,
            })
                .then((res) => {
                    this.loading = false;
                    console.log("getDefectInfoList  res.list:::",res.list)

                    if (Array.isArray(res.list)) {
                        this.defectInfoList = res.list.map(item => ({
                            ...item,
                            testDate: this.formatDate(item.testDate)
                        }));

                        console.log("this.testItemList:::",this.defectInfoList)
                        this.totalInfoSize = res.totalSize;
                        this.totalInfoPages = res.totalPages;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getDefectPipeList(){
            this.loading = true;
            fetchDefectPipeList({
                pageNum: this.pagePipeNum,
                pageSize: this.pagePipeSize,
                ...this.snForm,
            })
                .then((res) => {
                    this.loading = false;
                    if (Array.isArray(res.list)) {
                        this.tieInhList = res.list
                        console.log("this.tieInhList:::",this.tieInhList)
                        this.totalPipeSize = res.totalSize;
                        this.totalPipePages = res.totalPages;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        formatDate(dateString){
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        EditDefect(){
            this.tieInVisible = true;
            this.tieInInfo = this.tieInDetail;
        },
        addTieIn(item){
            this.tieInInfo = {};
            this.pipeInfo = {};
            this.visible = true;
            this.gisShow = false;
            if(item){
                this.proInfo = item;
            }

        },
        addProject(){
            this.projectInfo = {};
            this.projectVisible = true;
        },
        toggleUnfold(item) {
            this.$set(item, 'isUnfold', !item.isUnfold);
        },
        getUnfold(item) {
            item.isUnfold = !item.isUnfold;
            this.$forceUpdate();
            console.log("item::::",item)
        },
        projectDetailsText(item){
            console.log('projectDetailsText:::', item);
            this.projectVisible = true;
            this.projectInfo = item;
            this.isDetails = true;
        },
        projectEditText(item){
            this.projectVisible = true;
            this.projectInfo = item;
            this.isDetails = false;
        },
        roadEditText(item){
            this.tieInVisible = true;
            this.defect = item;
        },
        deleteItem(item, type) {
            console.log("deleteItem   item::   :",item.id,"   type:::",type)

            remove({
                id: item.id,
                type: type
            }).then((res) => {
                console.log("res:", res);
                this.getListMethod(type);
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        },
        getListMethod(type){
            switch (type) {
                case 'defect_test_item':
                    this.getTestItemList();
                    break;
                case 'defect_info':
                    this.getDefectInfoList();
                    break;
                case 'defect_pipe':
                    this.getDefectPipeList();
                    break;
                default:
                    console.warn(`未知类型: ${type}`);
            }
        },
        handleDefectPipeShowUpdate(item){
            console.log("handleDefectPipeShowUpdate:::",item)
            this.defectPipeInfo = item;
            this.pipeVisible = true;
        },
        handleDefectPipeInfoSave(){
            this.pipeVisible = false;
            this.defectPipeInfo = {};
        },
        handleDeletePipe(item) {
            this.deleteItem(item, 'defect_pipe', this.getDefectPipeList);
        },
        delProText(item) {
            this.deleteItem(item, 'defect_test_item', this.getTestItemList);
        },
        delPipeText(item) {
            this.deleteItem(item, 'defect_info', this.getDefectInfoList);
        },
        showChildren(item) {
            this.currentChildren = item.children || [];
        },
        handleTableAction(actionData) {
            if (actionData.type === 'showChildren') {
                // 处理子表格展示逻辑
                console.log('展示子表格', actionData.item);
            }
        }
    }
}
</script>
<style scoped>
.contain{
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin:2rem auto;
}
.containLeft{
    width: 60%;
}
.areaInfo{
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 1rem;
    margin-bottom: 1.5rem;
    height: 35vh;
}
.roadInfo{
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 1rem;
    height: 45vh;
}
.containright{
    width: 38%;
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 1rem;
    height: calc(80vh + 1.5rem);
}
.containTitle{
    font-size: 1rem;
    color: #00ff96;
    display: flex;
    align-items: center;
    height: 35px;
    line-height: 35px;
}
.roadInfo1{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin:0 0 0.5rem 0;
}
::v-deep .form-button{
    height: 35px;
}

.gisIndex{
    /*height: 80vh;*/
}

.projectInfo ::v-deep .input-container{
    height: 37px;
    line-height: 37px;
    padding: 0 0.5rem;
}
.projectInfo ::v-deep .form-input{
    height: 30px;
    line-height: 30px;
    padding-left: 0;
}
.pipeInfo ::v-deep .ant-input{
    height: 35px;
}
</style>